module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<div class='delete-confirmation js-prevent-toggle'>\n  <div class='delete-content-wrapper'>\n    <div class='delete-content'>\n      Are you sure?\n      <a class='js-cancel-delete pipe-separated' href='javascript:;' data-behavior='cancel-delete'>Cancel</a>\n      <a class='js-remove-asset pipe-separated' href='javascript:;'>Delete</a>\n    </div>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "").replace(/[\s\n]*\u0091/mg, '').replace(/\u0092[\s\n]*/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/story/templates/assets/asset_delete_confirmation.js.hamlc
// module id = 104
// module chunks = 15